import script from "./NavHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./NavHeader.vue?vue&type=script&setup=true&lang=js"

import "./NavHeader.vue?vue&type=style&index=0&id=0ae0f334&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ae0f334"]])

export default __exports__